import { createAction, createSlice } from "@reduxjs/toolkit";

const initialState = {
  reviews: [],
  pagination: {
    CurrentPage: 1,
    TotalPages: 1,
    PageSize: 10,
    TotalCount: 1,
    HasPrevious: false,
    HasNext: false,
  },
  processing: false,
  processingGetMore: false,
};

const getCourseReviewsSlice = createSlice({
  name: "getCourseReviews",
  initialState: initialState,
  reducers: {
    pending(state) {
      state.processing = true;
      /* TODO: reducer for pending*/
      state.reviews = [];
    },
    success(state, action) {
      const HasNext =
        action.payload.reviews.length === action.payload.pagination.PageSize;
      const pagination = { ...action.payload.pagination, HasNext };
      return {
        ...state,
        ...action.payload,
        processing: false,
        pagination,
      };
    },
    failure(state) {
      state.processing = false;
      state.processingGetMore = false;
      /* TODO: reducer for failure*/
    },
    clearAll() {
      return initialState;
    },
    clearReviews(state) {
      state.reviews = [];
    },
    updateUserReview(state, action) {
      const newReviews = [...state.reviews].map((review) => {
        if (review.id === action.payload.reviewId) {
          return {
            ...review,
            ...action.payload,
          };
        }
        return review;
      });
      state.reviews = newReviews;
    },
    // Pagination
    getMore(state) {
      state.processingGetMore = true;
    },
    getMoreSuccess(state, action) {
      const reviews = [...state.reviews, ...action.payload.reviews];
      const HasNext =
        action.payload.reviews.length === action.payload.pagination.PageSize;
      const pagination = { ...action.payload.pagination, HasNext };
      return {
        ...state,
        processingGetMore: false,
        reviews,
        pagination,
      };
    },
  },
});

const { name, actions, reducer } = getCourseReviewsSlice;
const getCourseReviewsAction = createAction(name);
const clearCourseReviewsAction = actions.clearAll;
const clearReviewsAction = actions.clearReviews;
const getMoreCourseReviewsAction = actions.getMore;

export {
  getCourseReviewsAction,
  clearCourseReviewsAction,
  clearReviewsAction,
  getMoreCourseReviewsAction,
  actions as getCourseReviewsActions,
  reducer as getCourseReviewsReducer,
};
